import { Button } from "components/Button/Button";
import { CardBoxAttachment } from "components/CardBoxAttachment/CardBoxAttachment";
import { DataGrid } from "components/DataGrid/DataGrid";
import { FileInput } from "components/FileInput/FileInput";
import { Fileviewer } from "components/Fileviewer/Fileviewer";
import { Footerbar } from "components/Footerbar/Footerbar";
import { Headerbar } from "components/Headerbar/Headerbar";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { SwitchBtn } from "components/SwitchBtn/SwitchBtn";
import { Toast } from "components/ToastShow/ToastAlert";
import { Toolbar } from "components/Toolbar/Toolbar";
import { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import { STORAGE_URL } from "utils/constants";
import { trans } from "utils/helpers";
import { DeleteAttachments, getAttachments, getAttachmentsFromTemp, getDownloadUrlAttachmentAsync, loadAttachment, MoveTemp, PostAttachments, putAsDefault, PutAttachments } from "./api/api";
import "./style.scss";
import { VersionList } from './VersionList/VersionList';
import { MessageType } from "types/enum";
import { ENDPOINTFILESTORAGE } from "utils/endpoints";

interface props {
    onHide: () => void
    ownerId?: string
    baseURL?: any
    mood?: string
    getListEndpoint?: any
    getListOwnerId?: any
    params?: any
    inTab?: string
    endpoint?: string
    showInGrid?: boolean
    haveVersion?: boolean
    temporaryOwnerIdCallBack?:any
    curentTabWithAttachment?:any
}
export const Attachment = ({ haveVersion=false,curentTabWithAttachment=null,temporaryOwnerIdCallBack,showInGrid=false , ownerId,baseURL=null,inTab, mood, onHide,getListEndpoint,params, getListOwnerId , endpoint}: props) => {


    let headerData, footerData;

    const [response, setResponse] = useState<Response | any>(null);
    const [selectedId, setSelectedId] = useState<string | any>(null);
    const [actionFormEditId, setActionFormEditId] = useState<any>();
    const [forceUpdate, setForceUpdate] = useState(false);
    const [showModalCarousel, setshowModalCarousel] = useState(false);
    const [listid, setId] = useState<any[]>([]);
    const [showVersions, setShowVersions] = useState(false);
    const [load, setLoad] = useState<any>();
    const [loading, setLoading] = useState<any>(false);
    const [index, setIndex] = useState<number | any>();
    const [showUpload, setShowUpload] = useState(false);
    const [flag, setFlag] = useState(false);
    const [exist, setExist] = useState(false);
    const [file, setFile] = useState<any>();
    const [temporaryOwnerId,setTemporaryOwnerId]=useState<any>(null)
    const [Name, setName] = useState<any>();
    const [showMode, setShowMode] = useState<any>(showInGrid ? null : true);
    const [selectedRow, setSelectedRow] = useState<any>();
    const [catchMessage, setCatchMessage] = useState<any>({type:"info",msg:"NoDataForPreview"});
    const [message, setMessage] = useState<any>( "NoDataForPreview");
    const [attachFile,setAttachFile]=useState<any>()




    /* #region pagination */

    const selectedIdCallback = (obj, index) => {
        setSelectedId(obj.Id);
    }


    const handleViewRow = () => {
        setActionFormEditId(selectedId);
    }
  
  const delay = (duration) =>
  new Promise(resolve => setTimeout(resolve, duration));

    const handleDeleteRow = async(atachId , isList = false ) => {
        setLoading(false)
        try {
                if(isList){
                    try {
                    await Promise.all(atachId.forEach(async(item) =>{
                            try {
                                const res = await DeleteAttachments( item.item.Id ,endpoint,baseURL,temporaryOwnerId && ownerId==null );                      
                            } catch (error) {
                            }
                        })
                        )
                    } catch (error) {
                    }
                }else{
                    const res = await DeleteAttachments( atachId ,endpoint ,baseURL,temporaryOwnerId && ownerId==null); 
                }
        } catch (error) {
            
        }
        try{
            await delay(200)
            setId([])
            getAttachmentsAsync(temporaryOwnerId && ownerId==null?true:false)
            setFile(null)

        }catch(err){
        }
        setLoading(true)
    }

    function handleDownload() {
        if(showMode){
            if (listid.length > 0) {
                let list:any = []
                listid.forEach(item => {
                    list.push({id:item.event.target.id, name :item.event.target.title })
                })
            downloadTrigger(list)
                setFlag(!flag)
                setId([])
            }else{
                // Toast(trans("nofileselected"), "warning")
                Toast(trans("nofileselected"), MessageType.warning)

            }
        }else{
            if(selectedRow){
                downloadTrigger([{id:selectedRow.Id,title:selectedRow.FileName}])
                setFlag(!flag)
                setId([])
            }
        }
    }
  function version (e) {
        setShowVersions(true)
        setAttachFile(e)

        
    }
    function checkbox(e , item) {
        if (e.target.checked === true) {
            setId((old) => [...old, {item:item , event:e}])
        } else if (listid.length !== 0 && e.target.checked === false) {
            let deleteId = listid.filter(file => {
                if(temporaryOwnerId && ownerId==null){
                    return item?.FileName !== file.item.FileName
                }else{
                    return item.Id !== file.item.Id
                }
            })
            setId(deleteId)
        }
    }

    function createDownloadlink(href, title) {
        const a = document.createElement('a');
        a.href = STORAGE_URL+ENDPOINTFILESTORAGE.File.browse+href
        a.download = title;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        return null
    }
    

    const asyncOperation = (message, delay) => {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(message);
          }, delay);
        });
      };
    
    async function downloadTrigger(e) {

        let ListId = e.map(item=>{
            return item.id
            })
            if(getListOwnerId && getListEndpoint){
                let tagList:any = []
                let res = await getDownloadUrlAttachmentAsync(ListId,endpoint ,baseURL);
                
                for (let i = 0; i < res?.Data.length; i++) {
                    const result = await asyncOperation("message", 400);
                    createDownloadlink(`${res?.Data[i]}`, e[i].name)
                }
       
            }else{

                let res = await getDownloadUrlAttachmentAsync(ListId,endpoint ,baseURL);
                
                for (let i = 0; i < res?.Data.length; i++) {
                    const result = await asyncOperation("message", 400);
                    createDownloadlink(`${res?.Data[i]}`, e[i].name)
                }

            }
            try {
        } catch (error) {
  
        }
       
    }


    function changehandlefile(e) {
        setExist(false)
        let flag= false

        if(!flag){
            var file = e.target.files[0]
            var blob = file.slice(0, file.size); 
            let newFile = new File([blob],  `${new Date().getTime()}.${e.target.files[0].name.split('.').pop().toLowerCase()}`, {
                type: file.type,
                lastModified: file.lastModified,
            } );
            // setFile(newFile)
            setFile({url: URL.createObjectURL(newFile)   ,file:newFile}); 

            setName( e.target.files[0].name)
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(newFile);
            let input:any =  document.getElementById("fileinputIdLegal")
            if(input != undefined){
                input!.files   = dataTransfer.files;   
            }
            
        }
    }
    function uploadSubmit(e) {
        console.log('a');
        
        e.preventDefault();
        if (file) {
            if(actionFormEditId){
                PutAttachment();
            }else{
                postAttachment();
            }
        }
    }

    async function postAttachment() {
        try {
            var _objData = new FormData();
            if(ownerId==null ){//اگر فرم در مد ایجاد هست و تا به حال پیوستی زده نشده و اونرآیدی نداریم
             _objData.append("file", file?.file);
           // _objData.append("tmpOwnerId", temporaryOwnerId);

            _objData.append("FileName", Name);
            if(response==null || response.length==0){
                _objData.append("IsDefault", "true");
            }
   const res = await PostAttachments(_objData ,endpoint  ,baseURL,'Temp',temporaryOwnerId);
            setShowUpload(false);
            setFile(null)
            if(!temporaryOwnerId){

                setTemporaryOwnerId(res?.Data)
                temporaryOwnerIdCallBack(res?.Data)
            }else{
                getAttachmentsAsync(true)
            }
            }else if( (ownerId && temporaryOwnerId==null)){//اگر مد در حالت ایجاد هست و تا بحال پیوست زده شده و اونرآیدی موقت داریم از ریسپانس درخواست پست تمپ یااگر فرم ثبت شده است و میخوایم به صورت جداگانه براش پیوست بزنیم مثل روال قبل
                     _objData.append("file", file?.file);
            _objData.append("OwnerId", temporaryOwnerId?temporaryOwnerId:ownerId );
            _objData.append("FileName", Name);
            if(response==null || response.length==0){
                _objData.append("IsDefault", "true");
            }
   const res = await PostAttachments(_objData ,endpoint  ,baseURL,"");
            setShowUpload(false);
            getAttachmentsAsync()
            setFile(null)
            }
        } catch (error) {
            
        }
    }
    async function PutAttachment() {
        try {
            var _objData = new FormData();
            _objData.append("file", file?.file);
            const res = await PutAttachments(_objData, ownerId ,endpoint ,actionFormEditId,baseURL);
            setShowUpload(false);
            getAttachmentsAsync()
            setFile(null)
        } catch (error) {
        }
    }

    /* #endregion */

    /* #region toolbarActions */
    const clickToolbarCallback = (clickedButtonName: string) => {
        switch (clickedButtonName.toLowerCase()) {
            case "print": alert("print "); break;
            case "refresh": setForceUpdate(!forceUpdate);getAttachmentsAsync(); break;
            case "create":setActionFormEditId(null); setShowUpload(true); break;
            case "view": if (selectedId) handleViewRow(); break;
            case "remove": if (listid.length > 0||selectedRow!=null){
                // Toast(trans("msg_deleteconfirm"), "warning" , "alert" , ()=>{handleDeleteRow(showMode?listid:selectedRow.Id , showMode)})
                Toast(trans("msg_deleteconfirm"), MessageType.confirmDelete, ()=>{handleDeleteRow(showMode?listid:
                    temporaryOwnerId && ownerId==null?selectedRow.FileName:
                    selectedRow.Id , showMode)})

            }else{ Toast(trans("nofileselected"), MessageType.warning)}; break;
            case "help": alert("call api help"); break;
            case "download": handleDownload(); break;
        }
    };
    /* #endregion */


    

    async function getAttachmentsAsync(getListFromTemp=false) {
        setLoading(false)
        try {
            
            if(getListOwnerId && getListEndpoint){
                const res = await getAttachments(getListOwnerId , getListEndpoint ,baseURL ,params ,showMode)
                setResponse(res.Data ) 
            }else{
                if(ownerId || temporaryOwnerId){
                    let res;
                    if(getListFromTemp){
                         res = await getAttachmentsFromTemp(temporaryOwnerId , endpoint ,baseURL ,params ,showMode)
                    }else{
                         res = await getAttachments(temporaryOwnerId?temporaryOwnerId:ownerId , endpoint ,baseURL ,params ,showMode)
                    }
                    setResponse(res.Data ) 
                }
            }
            setCatchMessage({type:"info",msg:"NoDataForPreview"})
        } catch (error:any) {
            setResponse(null)
            setMessage(error?.response?.data?.Message)
            setCatchMessage({type:"error" , msg:error?.response?.data?.Message})
        }
        setLoading(true)
    }
    
    function handleSlider(e) {
        let b = document.querySelectorAll(".CardBoxAttachment__img");
        for (let i = 0; i < b.length; i++) {
            if (e.target.id === b[i].id) {
                setIndex(i);
            }
        }
        loadAttachmentAsync(e.target.id);
        setshowModalCarousel(true);
    }


    function selectCarousel(I) {
        setIndex(I)
        let b = document.querySelectorAll(".CardBoxAttachment__img");
        for (let i = 0; i < b.length; i++) {
            loadAttachmentAsync(b[I].id);

        }
    }

  const  handleSetAsDefault=async(id)=>{


    try{
        await putAsDefault(endpoint ,baseURL,ownerId,id)
    }catch(error){

    }

    }
    async function loadAttachmentAsync(e) {
        try {
            if(getListOwnerId && getListEndpoint){
                const res:any = await loadAttachment(e ,getListEndpoint ,baseURL,params );
         
                setLoad(res);
                return res
            }else{

                const res:any = await loadAttachment(e ,endpoint ,baseURL ,params);
                setLoad(res);
                return res
            }
        } catch (error) {
            setLoad(" ")
            return " "
        }
    }
    useEffect(() => {
        if(showMode!==null){
            if(mood !== "create"){
                if(inTab && inTab==="Attachment"){
                    getAttachmentsAsync();
                }else if(inTab == null ||inTab === undefined ){
                    getAttachmentsAsync();
                }
            }else{
                if(ownerId==null && temporaryOwnerId==null){

                    setLoading(true)
                }else if(ownerId==null && temporaryOwnerId){
                    getAttachmentsAsync(true)// 
                }else{
                      if(inTab && inTab==="Attachment"){
                  //  getAttachmentsAsync();
                }else if(inTab == null ||inTab === undefined ){
                  //  getAttachmentsAsync();
                }
                }
            }
        }
    }, [ownerId ,inTab ,showMode,temporaryOwnerId])




    return (
        <>  
        
        {((inTab && inTab==="Attachment")||(inTab == null ||inTab === undefined))&& <>
    
            <div className={`cartable-action p-2 `}>
                <div className="row d-flex " >
                    {showInGrid&&
                <div className="col-12 col-md-2" >
                <SwitchBtn handleModeCard={(e)=>setShowMode(e)} setShape="circle"   firstMode="ascard" secondMode={'AsList'} parentModalName={'attachment'}  />
                </div>
                }
                <div className={showInGrid ? "col-10" : "col-12"}>
                  {  
                    (!curentTabWithAttachment || curentTabWithAttachment=="attachment")?
                    <Toolbar emptyList={response?.length==0}
                    download={temporaryOwnerId==null ||  ownerId==null?false:true}
                    warehouse={false}  excel={false}  remove={true} view={false} id={selectedId} create={mood !== "view" } edit={false} search={false}  handleClickToolbar={clickToolbarCallback}  />
                :
                <></>
                }
                </div>
                </div>
                {headerData && <Headerbar headerContents={headerData} hasBorder={true} />}
                <div className="card p-1">
                    <div className="">
                        {loading ?
                        (response && response?.length > 0 ?
                            <>
                            <div className={`modalCarousel ${showModalCarousel ? "d-flex" : "d-none"} `}  style={{zIndex: "14"}}>
                                    <div className="modalCarousel__close" onClick={() => { setshowModalCarousel(false); setLoad("") }} style={{top:"40px",right:"60px"}}>&#x2715;</div>
                                    <div className="container d-flex justify-content-center align-items-center">
                                        <Carousel indicators={false} interval={null} className={"modalCarousel__slide "} touch={true} onSelect={selectCarousel} defaultActiveIndex={index} activeIndex={index}>
                                            {response.map((item,mapIndex) => (
                                                <Carousel.Item className="attachCarousel" style={{minWidth:'1200px'}}>
                                                    {load ? <Fileviewer File={item.FileName } src={load} /> :
                                                        <Loading />
                                                    }
                                                </Carousel.Item>
                                            ))}
                                        </Carousel>
                                    </div>
                            </div>
                            
                                {showMode ?
                                <div className="row">
                                    <div className="Attachment d-flex flex-wrap">

                                        {response.map((item,mapIndex) => (

                                            <CardBoxAttachment haveVersion={temporaryOwnerId && ownerId==null?false:haveVersion}  handleEdit={ temporaryOwnerId && ownerId==null?null:()=>{setActionFormEditId(item.Id);setShowUpload(true)}} key={mapIndex} img={`data:image/jpg;base64,${item.Thumbnail}`} reset={flag} text={item.FileName} handleClickSlider={handleSlider} id={temporaryOwnerId && ownerId==null?item.FileName:item.Id}
                                            handleDeleteRow={handleDeleteRow}
                                            handleVersionTrigger={version}  handleCheckbox={checkbox} fileName={item.FileName} handleDownloadTrigger={temporaryOwnerId && ownerId==null?null:downloadTrigger}
                                            asDefault={temporaryOwnerId && ownerId==null?false:true} handleSetAsDefault={(e)=>handleSetAsDefault(e)}download={temporaryOwnerId && ownerId==null?false:true}
                                            />
                                         
                                        ))}
                                    </div>

                                </div>
                                    :

                                    <>
                                    <DataGrid
                                        parentName={"attachmentList"}
                                        startIndex={2}
                                        theadData={Object.keys(response[0])}
                                        tbodyData={response}
                                        minCellWidth={80}
                                        scrollHeight={"25vh"}
                                        selectedRowObjectCallback={(e)=>{setSelectedRow(e)}}
                                        rowSelected={selectedRow}
                                    />
                                </>


                            }
                                {footerData && <Footerbar footerContents={footerData} hasBorder={false} />}

                            </>
                            :<> <Message message={catchMessage.msg} type={catchMessage.type} />  </> 
                        )                    

                            : <Loading />}

                            <div className="col-lg-12 mt-1 btns_form">
                            <Button btnType="primary" value="Close" onClick={()=>{onHide && onHide()}}/>
                            </div>
                    </div>
                </div>
            </div>
            {
                showVersions &&
            <ModalForm title="VersionManagement" onHide={() => setShowVersions(false)} show={showVersions}>
                <VersionList reload={()=>{ setShowVersions(false);getAttachmentsAsync();}} getAllData={false} endpoint={endpoint} baseURL={baseURL} attachFile={attachFile} />
            </ModalForm>


            }

           { showUpload && <ModalForm title="upload" onHide={() => {setShowUpload(false);setFile(null)}} show={showUpload}>
                
                    <form onSubmit={uploadSubmit}>
                    {exist && <div className="fullscreen-bg-modal" />}

                        <FileInput maxSize={25600000}  lable={"file"} name={"file"} src={file  ? file?.url :""} onChange={changehandlefile} />
                        <div className="d-flex justify-content-end">
                            <Button disabled={exist} btnType="submit" value={"submit"} />
                            {/* <Button btnType="cancel" value={"cancel"} onClick={() => { Toast(trans("modalclosemessage"), "warning", "alert", () => {setShowUpload(false);setFile(null)}) }} /> */}
                            <Button btnType="cancel" value={"cancel"} onClick={() => { Toast(trans("modalclosemessage"), MessageType.confirm, () => {setShowUpload(false);setFile(null)}) }} />

                        </div>

                    </form>
                
            </ModalForm>
            }
                    
        </>}
        </>

    );
}




